import {
  AppliedFilterInterface,
  BlockStack,
  Button,
  FilterInterface,
  TextField,
} from '@shopify/polaris'
import { useCallback, useState } from 'react'

import { SubscriptionFilter } from '../api'

export const useAddNotesFilter = (
  filter: SubscriptionFilter,
  updateFilter: (newFilter: Partial<SubscriptionFilter>) => any,
  filters: FilterInterface[],
  appliedFilters: AppliedFilterInterface[]
) => {
  const [customerNote, setCustomerNote] = useState<string>(filter.customer_note ?? '')
  const [merchantNote, setMerchantNote] = useState<string>(filter.merchant_note ?? '')

  const onSet = useCallback(() => {
    updateFilter({
      customer_note: customerNote || undefined,
      merchant_note: merchantNote || undefined,
    })
  }, [updateFilter, customerNote, merchantNote])

  const onRemoveCustomerNote = useCallback(() => {
    updateFilter({ customer_note: undefined })
    setCustomerNote('')
  }, [updateFilter, setCustomerNote])

  const onRemoveMerchantNote = useCallback(() => {
    updateFilter({ merchant_note: undefined })
    setMerchantNote('')
  }, [updateFilter, setMerchantNote])

  filters.push({
    key: 'notes',
    label: 'Notes',
    filter: (
      <BlockStack gap="200">
        <TextField
          label="Customer note contains"
          value={customerNote}
          onChange={setCustomerNote}
          autoComplete="off"
        />
        <TextField
          label="Merchant note contains"
          value={merchantNote}
          onChange={setMerchantNote}
          autoComplete="off"
        />
        <Button onClick={onSet} size="large">
          Apply
        </Button>
      </BlockStack>
    ),
  })

  if (filter.customer_note) {
    appliedFilters.push({
      key: 'notes',
      label: `Customer note: ${filter.customer_note}`,
      onRemove: onRemoveCustomerNote,
    })
  }

  if (filter.merchant_note) {
    appliedFilters.push({
      key: 'notes',
      label: `Merchant note: ${filter.merchant_note}`,
      onRemove: onRemoveMerchantNote,
    })
  }
}
